import React, { useState } from 'react';
import { Typography, Button, Box, IconButton, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import CustomDialog from '../commoncomponents/CustomDialog';
import { useDispatch } from 'react-redux';
//import { checkFormSubmitForVendor, clearWebForm } from '../../redux/actions/vendor/webFormActions';
import { checkFormSubmitForVendor, clearWebForm } from '../../redux/actions/vendor/webFormActions'
import { routineInspectionClearWebForm } from '../../redux/actions/vendor/routineInspectionWebFormActions';
import { scmCheckFormSubmitForVendor } from '../../redux/actions/vendor/scmWebFormActions';

const BottomButtonForVendor = ({
  page = '',
  buttonAttributes,
  enableAuthorizeButton = false,
  saveButton = false,
  saveClick,
  authorizeButton = false,
  authorizeClick,
  continueButton = true,
  disableSave = false
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const findPageName = buttonAttributes.find((item) => item.currentPageName === page) || {};
  const { setPage, cancelButtonName, continueButtonName, backButtonName, backButton, previousPageName, cancelWO } = findPageName;


  const handleCloseCancelDialog = () => {
    setShowDeleteDialog(false);
  };

  const handleConfirmCancel = async () => {
    setShowDeleteDialog(false);
    dispatch(clearWebForm("CLEAR_WEB_FORM", {}));
     dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
    dispatch(routineInspectionClearWebForm("ROUTINEINSPECTION_CLEAR_WEB_FORM", {}));
    dispatch(checkFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", ""));
    dispatch(scmCheckFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", ""));
    navigate('/VendorDashboard');
  };

  const handleBackClick = () => {
    setPage(previousPageName);
  };

  const handleCancelClick = (e) => {
    setShowDeleteDialog(true);
  };

  return (
    <>
      <Stack
        pt={{ xs: 3, md: 8 }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ flexWrap: 'nowrap', width: '100%' }}
      >
        {backButton && (
          <Stack direction="row" alignItems="center" gap={1}>
            <IconButton aria-label="previous" onClick={handleBackClick}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="label" color="text.primary">
              {backButtonName}
            </Typography>
          </Stack>
        )}

        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Stack direction="row" spacing={2}>
            <Button variant="outlined" onClick={handleCancelClick} name="cancel">
              {cancelButtonName}
            </Button>
            {saveButton && (
              <Button variant="contained" onClick={saveClick} disabled={disableSave}>
                Save
              </Button>
            )}
            {authorizeButton ? (
              <Button variant="contained" disabled={enableAuthorizeButton} onClick={authorizeClick}>
                {continueButtonName}
              </Button>
            ) : continueButton ? (
              <Button variant="contained" disabled={enableAuthorizeButton} type="submit">
                {continueButtonName}
              </Button>
            ) : null}
          </Stack>
        </Box>

      </Stack>


      <CustomDialog
        open={showDeleteDialog}
        onClose={handleCloseCancelDialog}
        onConfirm={() => { handleConfirmCancel() }}
        content="Are you sure you want to cancel?"
        cancelBtn="No"
        confirmBtn="Yes"
      />

    </>
  );
};

export default BottomButtonForVendor;
